// Delegated so it also catches toggles added later, and menu items where the class sits on the <li>
document.addEventListener("click", function (e) {
    const toggle = e.target.closest(".cookie-settings-toggle");
    if (!toggle) return;

    e.preventDefault();
    // CookieHub's public API, the .ch2-open-settings-btn icon isn't always rendered (e.g. after consent)
    if (window.cookiehub && typeof window.cookiehub.openSettings === "function") {
        window.cookiehub.openSettings();
    } else {
        alert("Cookie-inställningarna är inte tillgängliga just nu.");
    }
});

//# sourceMappingURL=cookie-settings.js.map
